import { createAction, props } from "@ngrx/store";
import { FeeShareDto } from "./fee-sharing.dtos";
import { FeeShare } from "./fee-sharing.interfaces";

export const fetchFeeShare = createAction(
    '[Fee Module] fetch fee share'
)
export const fetchFeeShareFailed = createAction(
    '[Fee Module] fetch fee share failed'
)
export const fetchFeeShareSuccess = createAction(
    '[Fee Module] fetch fee share success',
    props<{feeShare: FeeShare[]}>()
)

export const createFeeShare = createAction(
    '[Fee Module] create fee share',
    props<{feeShareDto:{data: FeeShareDto[]}}>()
)
export const createFeeShareSuccess = createAction(
    '[Fee Module] create fee share success'
)
export const createFeeShareFailed = createAction(
    '[Fee Module] create fee share failed'
)

export const editFeeShare = createAction(
    '[Fee Module] edit fee share',
    props<{feeShareDto: FeeShareDto, id : string}>()
)
export const editFeeShareSuccess = createAction(
    '[Fee Module] edit fee share success'
)
export const editFeeShareFailed = createAction(
    '[Fee Module] edit fee share failed'
)


export const deleteFeeShare = createAction(
    '[Fee Module] delete fee share',
    props<{ id : string}>()
)
export const deleteFeeShareSuccess = createAction(
    '[Fee Module] delete fee share success'
)
export const deleteFeeShareFailed = createAction(
    '[Fee Module] delete fee share failed'
)
